<template>
	<div id="createModal" style="display: block" class="modal" role="dialog">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header text-center">
					<div class="cancelSection">
						<b-button
							class="btnSize cancelBtn"
							variant="secondary"
							:disabled="isUploading"
							@click="$emit('close')"
							>Cancel</b-button
						>
					</div>
					<div>
						<h3 class="titleText">Add Expense</h3>
					</div>
					<div class="updateSection">
						<b-button
							class="btnSize"
							variant="success"
							:disabled="isUploading"
							@click="createNew"
							>Done</b-button
						>
					</div>
				</div>
				<div class="modal-body">
					<file-pond
						accepted-file-types="image/jpeg, image/png"
						:instantUpload="false"
						:allow-multiple="true"
						ref="pond"
					/>
					<div v-if="isUploading" class="upload-progress-area">
						<b-progress
							class="upload-progress"
							:value="uploadProgressVal"
							:max="uploadProgressTotal"
							variant="success"
							show-progress
							animated
						></b-progress>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Storage from "@aws-amplify/storage";
import { getUserId } from "../utils/auth";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	name: "Create",
	data() {
		return {
			userId: getUserId(),
			previewImg: null,
			newReceiptId: null,
			isUploading: false,
			uploadProgressVal: 0,
			uploadProgressTotal: 100
		};
	},
	components: {
		FilePond
	},
	computed: mapState(["attributes"]),
	mounted() {},
	methods: {
		async getNewReceiptID() {
			await this.$axios.get("/receipt/getid", { crossdomain: true }).then(
				({ data }) => {
					this.newReceiptId = data.receiptId;
				},
				e => {
					console.log(e);
				}
			);
		},
		async createNew() {
			const images = this.$refs.pond.getFiles();
			const imagesLength = images.length;
			var self = this;
			this.isUploading = true;

			for (let i = 0; i < images.length; i++) {
				await self.getNewReceiptID();
				const img = images[i];
				self.uploadProgressVal = 0;

				await Storage.put(
					this.userId + "_" + this.newReceiptId + "." + img.fileExtension,
					img.file,
					{
						metadata: { source: "web" },
						progressCallback(progress) {
							self.uploadProgressVal = (progress.loaded * 100) / progress.total;
							self.uploadProgressTotal =
								(progress.total * 100) / progress.total;
							if (self.uploadProgressVal == self.uploadProgressTotal) {
								let pending_data = {
									InProgress: null,
									ReceiptId: self.newReceiptId,
									UserId: self.userId
								};
								self.$store.state.pendingExpense.receipts.push(pending_data);
								if (i + 1 === imagesLength) {
									self.$emit("close");
								}
								// const params = {
								//   user_id: self.userId
								// };
								// self.$axios
								//   .post("receipt/isnew", params, { crossdomain: true })
								//   .then(result => {
								//     self.isUploading = false;
								//     let pending_data = {
								//       InProgress: null,
								//       ReceiptId: self.newReceiptId,
								//       UserId: self.userId
								//     };
								//     self.$store.state.pendingExpense["receipts"].push(
								//       pending_data
								//     );
								//     self.$emit("close");
								//   });
							}
						}
					}
				);
			}
		},
		FileUpload(event) {
			var self = this;
			this.uploadImg = event.target.files[0];

			const reader = new FileReader();
			reader.readAsDataURL(this.uploadImg);
			reader.onload = event => {
				this.previewImg = event.target.result;
			};
		}
	}
};
</script>
